export const mypage = {
  heading: 'マイページ',
  logout: 'ログアウト',

  // セクション見出し
  nextLessonTitle: '次回レッスン',
  planTitle: 'プラン・残回数',
  pastLessonsTitle: '過去のレッスン',
  profileTitle: 'プロフィール',
  menuTitle: 'メニュー',

  // 次回レッスン
  joinMeet: 'Google Meetに参加する',
  sendNextSchedule: '次回のレッスン日程を送ってください',
  sendPreferred: '希望日時を送る →',
  waitingMatch: 'マッチング待ちです。確定したらメールでご連絡します。',
  partner: '相手：',

  // プラン・残回数
  noPlan: 'プランに登録するとレッスンを受けられます',
  viewPlans: 'プランを見る →',
  remainingLessons: '残りレッスン数',
  rolloverLessons: '繰越回数',
  nextRenewal: '次回更新：',
  planLabels: {
    basic: 'ベーシック（月4回）',
    plus2: 'プラス2（月6回）',
    plus4: 'プラス4（月8回）',
  },
  subscriptionStatus: {
    none: '未登録',
    active: 'アクティブ',
    paused: '一時停止中',
    cancelled: '解約済み',
    past_due: '支払い確認中',
  },

  // 過去のレッスン
  fillForm: 'フォームを記入 →',

  // プロフィール
  name: '名前',
  email: 'メールアドレス',
  country: '居住国',
  timezone: 'タイムゾーン',
  nativeLanguages: '母語',
  learningLanguages: '学習言語',
  editProfile: 'プロフィールを編集 →',

  // メニュー
  menu: {
    curriculum: '🗺️ カリキュラム進捗',
    schedule: '📅 レッスン希望日時を送る',
    plans: '💳 プラン選択・変更',
    wordPool: '📖 Word Pool',
    addWord: '✏️ 単語を投稿',
    postLesson: '📝 レッスン後フォーム',
    levelCheck: '🎯 レベルチェック',
    additionalLesson: '➕ 追加レッスン申請',
    contact: '📬 お問い合わせ',
    orgSchedule: '👥 団体スケジュール',
    adminDashboard: '🛠️ 運営ダッシュボード',
    adminMatching: '🔧 マッチング管理',
    adminWordPool: '🔧 Word Pool承認',
    adminLevelCheck: '🔧 レベルチェック結果',
  },
};
